import React, { useEffect, useRef, useState } from "react";
import { Client } from "@twilio/conversations";
import { ChevronDoubleLeftIcon } from "@twilio-paste/icons/esm/ChevronDoubleLeftIcon";
import { Box, Input } from "@twilio-paste/core";
import { ChevronDoubleRightIcon } from "@twilio-paste/icons/esm/ChevronDoubleRightIcon";

import CreateConversationButton from "./CreateConversationButton";
import ConversationsList from "./ConversationsList";
import styles from "../../styles";

import { useDispatch, useSelector } from "react-redux";
import { filterConversations } from "./../../store/action-creators";
import { AppState } from "../../store";
import { getTranslation } from "./../../utils/localUtils";

interface ConvosContainerProps {
  client?: Client;
  isMobile?: boolean;
  searchFocusSignal?: number;
}

const ConversationsContainer: React.FC<ConvosContainerProps> = (
  props: ConvosContainerProps
) => {
  const [listHidden, hideList] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();

  const local = useSelector((state: AppState) => state.local);
  const search = getTranslation(local, "convoSearch");

  const handleSearch = (searchString: string) => {
    dispatch(filterConversations(searchString));
  };

  const collapsed = !props.isMobile && listHidden;

  useEffect(() => {
    if (!props.isMobile || !props.searchFocusSignal) {
      return;
    }

    searchInputRef.current?.focus();
    searchInputRef.current?.select();
  }, [props.isMobile, props.searchFocusSignal]);

  return (
    <Box
      style={
        collapsed
          ? { ...styles.convosWrapper, ...styles.collapsedList }
          : {
              ...styles.convosWrapper,
              width: props.isMobile ? "100%" : styles.convosWrapper.width,
            }
      }
    >
      <Box style={styles.newConvoButton}>
        <CreateConversationButton client={props.client} collapsed={collapsed} />
        {!collapsed ? (
          <Box marginTop="space60">
            <Input
              ref={searchInputRef}
              aria-describedby="convo_string_search"
              id="convoString"
              name="convoString"
              type="text"
              placeholder={search}
              onChange={(e) => handleSearch(e.target.value)}
              required
              autoFocus={!props.isMobile}
            />
          </Box>
        ) : null}
      </Box>
      <Box style={styles.convoList}>
        {!collapsed ? <ConversationsList isMobile={props.isMobile} /> : null}
      </Box>
      {!props.isMobile ? (
        <Box style={styles.collapseButtonBox}>
          <Box
            paddingTop="space30"
            style={{
              paddingLeft: 10,
              paddingRight: 10,
            }}
            onClick={() => hideList(!listHidden)}
          >
            {listHidden ? (
              <ChevronDoubleRightIcon decorative={false} title="Collapse" />
            ) : (
              <ChevronDoubleLeftIcon decorative={false} title="Collapse" />
            )}
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};

export default ConversationsContainer;
